import React from "react";

function Loading({ message }) {
  return (
    <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-white/80 dark:bg-black/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-solid border-brand-500 border-t-transparent"></div>
        <span className="text-sm text-gray-500 dark:text-gray-400 font-medium">
          {message || "Lütfen Bekleyiniz.."}
        </span>
      </div>
    </div>
  );
}

export default Loading;
